export default "__VITE_ASSET__BFvpMn4K__"